export enum LectureType {
  ELearning = "E_LEARNING",
  LiveLearning = "LIVE_LEARNING",
  FlipLearning = "FLIP_LEARNING",
  SPECIAL_TRACK = "SPECIAL_TRACK"
}
